import * as TypeGraphQL from "type-graphql";
export var JsonNullValueInput;
(function (JsonNullValueInput) {
    JsonNullValueInput["JsonNull"] = "JsonNull";
})(JsonNullValueInput || (JsonNullValueInput = {}));
TypeGraphQL.registerEnumType(JsonNullValueInput, {
    name: "JsonNullValueInput",
    description: undefined,
});
//# sourceMappingURL=JsonNullValueInput.js.map